import aspectRatio from "@tailwindcss/aspect-ratio";
import { Config } from "tailwindcss";
import tailwindColors, { gray } from "tailwindcss/colors";
import defaultTheme from "tailwindcss/defaultTheme";

import { colors } from "./frontend/tailwindV1Colors";

// const { colors } = require("./frontend/tailwindV1Colors");
// const tailwindColors = require("tailwindcss/colors");

/* This is less than ideal
 But onsite use the default tailwind fontsizes and the management site does not.
 in order to get the correct font sizes in the mobile menu preview we need to manually import them
 if we ever fix the management site typography we can remove this
 The these fonts are being used in the menus.css to overide the text-* classes in #MobileMenuPreview
 */
const BUSTLE_COLORS = {
  pinkIcing: "#FBE7f2",
  chalkboard: "#2A2A2E",
  cream: "#fcfaf4",
  coolBlue: "#2748f2",
  croissant: "#cf8d0e",
};
const veneuePreviewFontSizes = Object.entries(defaultTheme.fontSize).reduce(
  (acc, [key, value]) => ({
    ...acc,
    [`venue-preview-${key}`]: value,
  }),
  {},
);
export default {
  important: "#bustleApp",
  content: [
    "./frontend/app/**/*.{js,ts,tsx,jsx}",
    "./frontend/onsite_app/*.{js,ts,tsx,jsx}",
    "./frontend/onsite_app/**/*.{js,ts,tsx,jsx}",

    "./frontend/welcome/*.{js,ts,tsx,jsx}",
    "./frontend/welcome/**/*.{js,ts,tsx,jsx}",
    "./app/views/**/*.html.erb",
  ],
  theme: {
    screens: {
      // Less than this equates to phones
      sm: "640px",
      // => @media (min-width: 640px) { ... }

      // Between these two value is generally an iPad in portrait mode
      // This is also 124px bigger than Tailwinds so that the side bar
      // doesn't show on the portrait ipad
      md: "896px",
      // => @media (min-width: 896px) { ... }

      // Anything bigger than this is a desktop
      lg: "1024px",
      // => @media (min-width: 1024px) { ... }

      xl: "1280px",
      // => @media (min-width: 1280px) { ... }

      "2xl": "1536px",

      print: { raw: "print" },
    },
    spacing: {
      "-24": "-24px",
      0: "0px",
      2: "2px",
      4: "4px",
      8: "8px",
      12: "12px",
      16: "16px",
      24: "24px",
      32: "32px",
      48: "48px",
      64: "64px",
      96: "96px",
      128: "128px",
      192: "192px",
      256: "256px",
      384: "384px",
      512: "512px",
      640: "640px",
    },
    fontSize: {
      xs: "12px",
      base: "14px",
      lg: "16px",
      xl: "20px",
      "2xl": "24px",
      "3xl": "30px",
      "4xl": "36px",
      "5xl": "48px",
      "6xl": "64px",
      ...veneuePreviewFontSizes,
    },
    colors: {
      // Used for the online menus and online ordering
      venue: {
        primary: "var(--venue-primary)",
        secondary: "var(--venue-secondary)",
        tertiary: "var(--venue-tertiary)",
        highlight: "var(--venue-highlight)",
      },
      // This one should be removed when its seen in the bustle app
      primary: {
        100: "#E0E6EB",
        200: "#D3E5FD",
        300: "#82A3BF",
        400: "#4A7191",
        500: "#2F4860",
        1000: "#1C2C3A",
      },

      // Generated https://uicolors.app/create using
      accent: {
        "50": "#edf5ff",
        "100": "#ddedff",
        "200": "#c2dcff",
        "300": "#9dc4ff",
        "400": "#77a1ff",
        "500": "#567ffe",
        "600": "#2748f2",
        "700": "#2b44d7",
        "800": "#263cad",
        "900": "#273988",
        "950": "#17204f",
      },

      // Prefer neutral unless you are wanting to intentionally contrast with the bustle-chalkboard
      neutral: gray,
      // Generated https://uicolors.app/create using
      chalkboard: {
        "50": "#f7f7f8",
        "100": "#eeeef0",
        "200": "#dadadd",
        "300": "#b9bac0",
        "400": "#93949d",
        "500": "#757682",
        "600": "#5f5f6a",
        "700": "#4e4e56",
        "800": "#42424a",
        "900": "#3a3a40",
        "950": BUSTLE_COLORS.chalkboard,
      },

      croissant: {
        "50": "#fdfbe9",
        "100": "#fbf6c6",
        "200": "#f9ea8f",
        "300": "#f5d74f",
        "400": "#f0c21f",
        "500": "#e0aa12",
        "600": BUSTLE_COLORS.croissant,
        "700": "#9a5e0e",
        "800": "#804b13",
        "900": "#6d3d16",
        "950": "#3f1f09",
      },

      background: BUSTLE_COLORS.cream,
      "sogui-brand": {
        100: "#FFEDC9",
        200: "#FFE8ED",
        500: "#F4406B",
        green: "#66F343",
      },
      "regulr-pink": "#f1655f",
      "regulr-brand": "#F44336",
      bustle: {
        "pink-icing": BUSTLE_COLORS.pinkIcing,
        chalkboard: BUSTLE_COLORS.chalkboard,
        cream: BUSTLE_COLORS.cream,
        "cool-blue": BUSTLE_COLORS.coolBlue,
        croissant: BUSTLE_COLORS.croissant,
        unknown: colors.purple[500],
      },
      black: colors.black,
      white: colors.white,
      red: colors.red,
      green: colors.green,

      // We want to aim to use these colors as little as possible, maybe removing the usage all together
      // They are only really being used in the profit report / did i make money report  atm
      orange: colors.orange,
      blue: colors.blue,

      transparent: "transparent",
      current: "currentColor",
    },
    extend: {
      maxWidth: {
        "5/6": "calc(100%/6 * 5)",
        256: "256px",
      },
      animation: {
        "small-bounce": "small-bounce 1s linear infinite",
        "dnd-wiggle": "dnd-wiggle 0.7s 0.3s ease-in 1",
      },
      keyframes: {
        // 0%, 100% {
        //   transform: translateY(-25%);
        //   animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
        // }
        // 50% {
        //   transform: translateY(0);
        //   animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
        // }
        "small-bounce": {
          ["0%, 100%"]: {
            transform: "translateY(-5%)",
            animationTimingFunction: "cubic-bezier(0.8, 0, 1, 1)",
          },
          ["50%"]: {
            transform: "translateY(0)",
            animationTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
          },
        },
        "dnd-wiggle": {
          "0%, 100%": {
            transform: "translateX(0px)",
          },
          "50%": {
            transform: "translateX(15px)",
          },
        },
      },
      maxHeight: {
        0: "0px",
        "4/5": "80%",
        192: "192px",
      },
      minHeight: {
        "4/5": "80%",
        256: "256px",
      },
      minWidth: {
        0: "0",
        48: "48px",
        "1/10": "10%",
      },
      boxShadow: {
        outline: "0 0 0 2px rgba(139, 191, 255,0.5)",
        "venue-brand-style": "var(--venue-box-shadow)",
        brutalist: `4px 4px 0px 0 var(--tw-shadow-color)`,
      },
      cursor: {
        grab: "grab",
      },
      borderRadius: {
        phone: "28px",
        "venue-brand": "var(--venue-border-radius)",
      },
      aspectRatio: {
        ipad: "4/3",
      },
    },
    transitionProperty: {
      "margin-left": "margin-left",
      "margin-bottom": "margin-bottom",
      height: "height",
    },
  },
  plugins: [aspectRatio],
} satisfies Config;
